/**
 * Turns a snake_case enum value into a human-readable label,
 * e.g. "dec_page" -> "Dec Page", "general_liability" -> "General Liability".
 */
export function humanizeEnum(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .split('_')
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
    .join(' ');
}
